import { CONSTANTS } from './../../Constants/Constant/index'
/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PARAMETER_MANAGEMENT_CRUD, WIDGET_MANAGEMENT_CRUD } from '../../Constants/ApiDefinations'
import mainApiService from '../../Services'
import { logger } from '../../Helpers'

const initialState: any = {
  fetchedAssetsList: [],
  payloadForSaveAction: {},
  copyPayloadForSaveAction: {},
  pinnedAssetIdsForSaveAction: [],
}

const dataEngineCategorySlice = createSlice({
  name: 'dataEngineCategory',
  initialState,
  reducers: {
    setFetchedAssetsList: (state, action: PayloadAction<any>) => {
      state.fetchedAssetsList = action.payload
    },
    clearFetchedAssetsList: (state) => {
      state.fetchedAssetsList = []
    },
    setStorePayloadForSaveAction: (state, action: PayloadAction<any>) => {
      state.payloadForSaveAction = action.payload
    },
    setCopyStorePayloadForSaveAction: (state, action: PayloadAction<any>) => {
      state.copyPayloadForSaveAction = action.payload
    },
    clearPayloadForSaveAction: (state) => {
      state.payloadForSaveAction = {}
      state.pinnedAssetIdsForSaveAction = []
    },
    setStorePinnedAssetIdsForSaveAction: (state, action: PayloadAction<any>) => {
      state.pinnedAssetIdsForSaveAction = action.payload
    },
  },
})
export const {
  setFetchedAssetsList,
  setStorePayloadForSaveAction,
  setCopyStorePayloadForSaveAction,
  clearPayloadForSaveAction,
  setStorePinnedAssetIdsForSaveAction,
  clearFetchedAssetsList,
} = dataEngineCategorySlice.actions

const dataEngineCategorySelector = (state: { dataEngineCategory: any }) => state.dataEngineCategory

export const selectFetchedAssetsList = createSelector(
  dataEngineCategorySelector,
  (state) => state.fetchedAssetsList,
)

export const selectPayloadForSaveAction = createSelector(
  dataEngineCategorySelector,
  (state) => state.payloadForSaveAction,
)

export const createCopyPayloadForSaveAction = createSelector(
  dataEngineCategorySelector,
  (state) => state.copyPayloadForSaveAction,
)

export const selectPinnedAssetIdsForSaveAction = createSelector(
  dataEngineCategorySelector,
  (state) => state?.pinnedAssetIdsForSaveAction,
)

export default dataEngineCategorySlice

const mastersCache = new Map<string, Promise<any>>()

export const clearMastersCache = (moduleName?: string) => {
  if (moduleName) {
    for (const key of Array.from(mastersCache.keys())) {
      if (key.startsWith(`${moduleName}:`) || key.includes(`:${moduleName}:`)) {
        mastersCache.delete(key)
      }
    }
  } else {
    mastersCache.clear()
  }
}

const getCacheKey = (payload: any): string => {
  const modulePrefix = payload?.module ? `${payload.module}:` : ''
  if (typeof payload === 'object' && payload !== null) {
    return `${modulePrefix}:${payload.url || ''}:${JSON.stringify(payload.body || {})}`
  }
  return `${modulePrefix}:${String(payload)}`
}

export const getMastersData = createAsyncThunk(
  'dataEngineCategory/getMastersData',
  async (payload: any, { dispatch }) => {
    const cacheKey = getCacheKey(payload)
    if (mastersCache.has(cacheKey)) {
      return await mastersCache.get(cacheKey)
    }

    const fetchPromise = (async () => {
      try {
        const requestedObj: any = {}
        if (
          payload.url?.includes('system-configurations') ||
          payload.url?.includes('blitz-master')
        ) {
          requestedObj['url'] = payload.url
          requestedObj['method'] = CONSTANTS.HTTP_METHOD.GET
          requestedObj['data'] = {}
        } else {
          requestedObj['url'] = payload.url
          requestedObj['method'] = CONSTANTS.HTTP_METHOD.POST
          requestedObj['data'] = payload?.body
        }

        const requestedData: any = requestedObj
        const data: any = await mainApiService(requestedData)
        return {
          key: payload,
          data: data,
        }
      } catch (error) {
        logger.error(error)
      }
    })()

    mastersCache.set(cacheKey, fetchPromise)
    return await fetchPromise
  },
)

export const getAutomatedMastersData = createAsyncThunk(
  'dataEngineCategory/getMastersData',
  async (payload: any, { dispatch }) => {
    const cacheKey = getCacheKey(payload)
    if (mastersCache.has(cacheKey)) {
      return await mastersCache.get(cacheKey)
    }

    const fetchPromise = (async () => {
      try {
        const requestedObj: any = {}
        let targetUrl = payload.url || ''
        if (targetUrl.includes('country') && !targetUrl.includes('isDropDown=true')) {
          targetUrl = targetUrl + '?isDropDown=true'
        }
        requestedObj['url'] = targetUrl
        requestedObj['method'] = CONSTANTS.HTTP_METHOD.GET

        const requestedData: any = requestedObj
        const data = await mainApiService(requestedData)
        return {
          key: payload,
          data: data,
        }
      } catch (error) {
        logger.error(error)
      }
    })()

    mastersCache.set(cacheKey, fetchPromise)
    return await fetchPromise
  },
)

export const getParameterRepositoryDetail = createAsyncThunk(
  'dataEngineCategory/getParameterRepositoryDetail',
  async (payload: any, { dispatch }) => {
    const cacheKey = getCacheKey(payload)
    if (mastersCache.has(cacheKey)) {
      return await mastersCache.get(cacheKey)
    }
    const fetchPromise = (async () => {
      try {
        const requestedData: any = PARAMETER_MANAGEMENT_CRUD.VIEW_PARAMETER(payload)
        const data: any = await mainApiService(requestedData)
        return data
      } catch (error) {
        logger.error(error)
      }
    })()

    mastersCache.set(cacheKey, fetchPromise)
    return await fetchPromise
  },
)

export const submitDataEngineAutomatedFormAPICall = createAsyncThunk(
  'dataEngineCategory/submitDataEngineAutomatedFormAPICall',
  async (payload: any, { dispatch }) => {
    const requestedData: any = WIDGET_MANAGEMENT_CRUD.AUTOMATTED_ADD(payload)
    const data: any = await mainApiService(requestedData)
    return data
  },
)

export const saveWidgetDataCategory = createAsyncThunk(
  'dataEngineCategory/saveWidgetDataCategory',
  async (payload: any, { dispatch }) => {
    const requestedData: any = WIDGET_MANAGEMENT_CRUD.WIDGET_AUTOMATTED_ADD(payload)
    const data: any = await mainApiService(requestedData)
    return data
  },
)

export const updateWidgetDataCategory = createAsyncThunk(
  'dataEngineCategory/updateWidgetDataCategory',
  async (payload: any, { dispatch }) => {
    const requestedData: any = WIDGET_MANAGEMENT_CRUD.WIDGET_AUTOMATTED_UPDATE(payload)
    const data: any = await mainApiService(requestedData)
    return data
  },
)
